import React, { createContext, useEffect } from "react";
import { SubscriptionModalType, SubscriptionModalTypeChild, SubscriptionModalTypeContext } from "./lib/types/subscription-modal-types";
import "./lib/index.css";
import useOutside from "../../../../../shared/hooks/useOutside";
import { ReactComponent as Close } from "./lib/icons/closeModal.svg";

const SubscriptionModalContext = createContext<SubscriptionModalTypeContext>({ closeModal: null})

export function SubscriptionModal({isOpenModal, closeModalAction, outsideClosing, children, styleWindow}:SubscriptionModalType) {
    const refCloseModal = useOutside(()=> closeModalAction(false))

    useEffect(() => {
    if (isOpenModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpenModal]);

    if (!isOpenModal) return null

    return (
        <SubscriptionModalContext.Provider value={{closeModal: closeModalAction}}>
            <div className="sub-modal-overlay">
                <div ref={refCloseModal} className="sub-modal-window" style={styleWindow}>
                        <Close className="sub-modal-window__close-btn-icon" onClick={() => closeModalAction(false)}/>
                    {children}
                </div>
            </div>
        </SubscriptionModalContext.Provider>
    )
}

const SubModalHeader = ({children, typeBackground}: SubscriptionModalTypeChild) => {

    return (
        <div className={`sub-modal-header ${typeBackground}` }>
            {children}
        </div>
    )
}

const SubModalContent = ({children}: SubscriptionModalTypeChild) => {
    return (
        <div className="sub-modal-content">
            {children}
        </div>
    )
}

const SubModalFooter = ({children}: SubscriptionModalTypeChild) => {
    return (
        <div className="sub-modal-footer">
            {children}
        </div>
    )
}

SubscriptionModal.Header = SubModalHeader;
SubscriptionModal.Content = SubModalContent;
SubscriptionModal.Footer = SubModalFooter;